import { useRouter } from 'next/router';
import { useEffect } from 'react';

// scrolling position session id in current path
const pathname =
  (typeof document !== 'undefined' && document.location && document.location.pathname) || '';
const scrollPositionSessionId = `productListScrollPosition_${pathname}`;

export const useScrollRestoration = () => {
  useEffect(() => {
    // scroll back to prior select product position
    if (
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      window.sessionStorage[scrollPositionSessionId]
    ) {
      window.scrollTo(0, window.sessionStorage[scrollPositionSessionId]);
      window.sessionStorage.removeItem(scrollPositionSessionId);
    }
  }, []);
};

export const setScrollingPosition = () => {
  if (typeof window !== 'undefined' && window.scrollY && window.sessionStorage) {
    // set scrolling position in session storage
    window.sessionStorage.setItem(scrollPositionSessionId, window.scrollY.toString());
  }
};

export const rememberPageData = (sku: string, path: string) => {
  window.sessionStorage.setItem('rememberedPageData', JSON.stringify({ sku, path }));
};

export const useRememberedPagedata = () => {
  const { asPath } = useRouter();

  useEffect(() => {
    const pageData = window.sessionStorage.getItem('rememberedPageData');
    if (pageData) {
      const rememberedData = JSON.parse(pageData);
      if (rememberedData.path === asPath) {
        const element = document.getElementById(rememberedData.sku);
        if (element) {
          requestAnimationFrame(() => element.scrollIntoView({ block: 'center' }));
        }
      }
      window.sessionStorage.removeItem('rememberedPageData');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath]);
};
